<template>
  <div>
    <ca-row>
      <ca-col size="2">
        <ca-button full-width @click="onEdit">Editar</ca-button>
      </ca-col>
      <ca-col size="2">
        <ca-button full-width @click="onDelete">Excluir</ca-button>
      </ca-col>
    </ca-row>

    <ca-row vertical-offset="2">
      <ca-col>
        <ca-page>
          <ca-async-content-wrapper
            :on-fetch="getUnion"
            :on-fetch-success="setUnion">
            <div v-if="union">
              <ca-row>
                <ca-col size="4">
                  <ca-field label="Nome">
                    {{ union.name }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                  <ca-field label="CNPJ">
                    {{ union.register }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                  <ca-field label="Mês da data base da categoria">
                    {{ union.categoryBaseDateDay }}
                  </ca-field>
                </ca-col>
              </ca-row>

              <ca-row>
                <ca-col size="4">
                  <ca-field label="Código Sindical">
                    {{ union.code }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                  <ca-field label="Tipo de divisão de Médias">
                    {{ union.monthAvgDivisionType.description }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                  <ca-field label="Quantidade de meses em média de Férias">
                    {{ union.vacationMonthAvg }}
                  </ca-field>
                </ca-col>
              </ca-row>

              <ca-row>
                <ca-col size="4">
                  <ca-field label="Quantidade de meses em média de 13º">
                    {{ union.thirteenMonthAvg }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                  <ca-field label="Quantidade de meses em média de Aviso Prévio">
                    {{ union.noticeTerminationMonthAvg }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                  <ca-field label="Percentual Adicional Noturno Diferenciado">
                    {{ union.nightShiftPremiumPct }}
                  </ca-field>
                </ca-col>
              </ca-row>

              <ca-row>
                <ca-col size="4">
                  <ca-field label="Compartilhado">
                    {{ union.shared ? 'Sim' : 'Não' }}
                  </ca-field>
                </ca-col>
              </ca-row>
            </div>
          </ca-async-content-wrapper>
        </ca-page>
      </ca-col>
    </ca-row>
  </div>
</template>

<script>
import {
  DELETE_TITLE, DELETE_MESSAGE, DELETE_CONFIRM_TEXT, DELETE_SUCCESS_MESSAGE,
} from './constants';
import { getUnion, deleteUnion } from './unionService';
import { getErrorMessageFromResponse } from '../../../packages/common';

export default {
  name: 'UnionsViewPage',
  data() {
    return {
      union: null,
      unionId: this.$route.params.id,
    };
  },
  methods: {
    getUnion() {
      return getUnion(this.unionId);
    },
    setUnion(union) {
      this.union = union;
    },
    onEdit() {
      this.$router.push({ name: 'EditUnion', params: { id: this.unionId } });
    },
    onDelete() {
      this.$caConfirm({
        title: DELETE_TITLE,
        message: DELETE_MESSAGE,
        confirmButtonText: DELETE_CONFIRM_TEXT,
        onConfirm: () => {
          deleteUnion(this.unionId)
            .then(() => {
              this.$toaster.success(DELETE_SUCCESS_MESSAGE);
              this.$router.back();
            })
            .catch(e => {
              this.$toaster.error(getErrorMessageFromResponse(e));
            });
        },
      });
    },
  },
};
</script>
